module.exports = __webpack_public_path__ + "static/media/iamfluidics.2edd7a84.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/iamfluidics.webp
// module id = 263
// module chunks = 0